import {AgentHandoffFlowRestService} from './restServices';
import utilsService from '../utilsService';

var service = {};

service.handoffToAgent = async (
  ownerObjectType,
  ownerObjectId,
  parentWidgetId,
  chatRoomId,
) => {
  const requestObj = {
    ownerObjectType,
    ownerObjectId,
    parentWidgetId,
    chatRoomId,
  };
  const response = await AgentHandoffFlowRestService.save(
    {endpoint: 'handoffToAgent'},
    requestObj,
  );

  utilsService.logApiResponse('handoffToAgent', response.data);
  return response.data;
};

const agentHandoffService = {...service};
export default agentHandoffService;
